var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuoteBeforeFilled = function SvgQuoteBeforeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 75 57"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M30 11.102c-11.28.48-15.36 5.28-15.36 14.4 12.24 0 19.2 6.96 19.2 16.08 0 8.64-6.48 15.12-15.84 15.12-10.08 0-18-7.44-18-24.48C0 12.061 11.52.301 28.08.301H30zm10.72 21.12c0-20.16 11.52-31.92 28.08-31.92h1.92v10.8c-11.28.48-15.36 5.28-15.36 14.4 12.24 0 19.2 6.96 19.2 16.08 0 8.64-6.48 15.12-15.6 15.12-10.08 0-18.24-7.44-18.24-24.48",
    opacity: 0.1
  })));
};
export default SvgQuoteBeforeFilled;